import React, { useState } from "react";
import styles from "./callsentry.module.css";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { motion } from "framer-motion";
import Pricing from "../Pricings/pricing";
import { FaBullseye, FaPhoneAlt, FaUniversity, FaUsers } from "react-icons/fa";
import ContactUs from "../contact/ContactUs";
import psshealth from "../../asset/psshealthimg.jpg";
import Loan from "../../asset/Loan.png";

const Projects = () => {
  const [filter, setFilter] = useState("all");

  const projects = [
  {
    id: 1,
    title: "RealTor - Real Estate Voice Bot",
    category: "voice",
    description:
      "AI-powered real estate voice agent that handles property inquiries, schedules site visits, qualifies buyers, and automates lead follow-ups.",
    status: "in-progress",
    date: "2024-05-10",
    image: psshealth,
    tech: ["Node.js", "Twilio", "OpenAI", "Express"],
    link: "/projects/realtor-voice-bot",
  },
  {
    id: 2,
    title: "RecoveryPro - Bank Recovery Voice Agent",
    category: "voice",
    description:
      "Intelligent AI voice agent designed for banks and NBFCs to automate loan recovery calls, payment reminders, and customer follow-ups with compliance handling.",
    status: "completed",
    date: "2024-04-18",
    image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    tech: ["Python", "Twilio", "LLMs", "PostgreSQL"],
    link: "/projects/recoverypro",
  },
  {
    id: 3,
    title: "Voice Agent for Elections",
    category: "voice",
    description:
      "AI-driven election campaign voice agent for voter outreach, surveys, feedback collection, and automated constituency engagement.",
    status: "planning",
    date: "2024-05-02",
    image:
      "https://images.unsplash.com/photo-1541872703-74c5e44368f9?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
    tech: ["Node.js", "Twilio", "Speech-to-Text", "OpenAI"],
    link: "/projects/election-voice-agent",
  },
  {
    id: 4,
    title: "Mortgage Service Agent - Finance & Loan Assistant",
    category: "voice",
    description:
      "AI voice assistant for mortgage and loan services that handles EMI reminders, loan eligibility checks, document guidance, and customer support automation.",
    status: "in-progress",
    date: "2024-05-15",
    image: Loan,
    tech: ["Python", "FastAPI", "Twilio", "MongoDB"],
    link: "/projects/mortgage-service-agent",
  }
];


  const categories = [
    {
      id: "voice",
      name: "Voice",
      count: projects.filter((p) => p.category === "voice").length,
    },
  ];

  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((project) => project.category === filter);

  return (
    <div className={styles.projectsContainer}>
      <Navbar />

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.productSlogan}>
            <h3 className={styles.heroTitle}>
              The Future of Lead Management
            </h3>
            <p className={styles.heroSubtitle}>
              CallCentry is an advanced AI system that automates outbound calls,
              engages customers directly from your CRM with relevant mortgage
              information, and intelligently transfers interested leads to human
              agents.
            </p>
          </div>
        {/* <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Our Products</h1>
          <p className={styles.heroSubtitle}>
            Explore our portfolio of AI-powered solutions and innovative
            implementations. From voice analytics to intelligent chatbots, see
            how we transform ideas into reality.
          </p>
        </div> */}
        

        {/* Active Animated Bot Icon */}
        <div className={styles.activeBotIcon}>
          <div className={styles.botMain}>
            {/* Antenna */}
            <div className={styles.botAntenna}></div>

            {/* Head */}
            <div className={styles.botHead}>
              {/* Pulsing screen */}
              <div className={styles.botScreen}>
                <div className={styles.screenLine}></div>
                <div className={styles.screenLine}></div>
                <div className={styles.screenLine}></div>
              </div>

              {/* Animated eyes */}
              <div className={styles.botEyes}>
                <div className={styles.eye}>
                  <div className={styles.eyeDot}></div>
                </div>
                <div className={styles.eye}>
                  <div className={styles.eyeDot}></div>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className={styles.botBody}>
              {/* Status lights */}
              <div className={styles.statusLights}>
                <div
                  className={`${styles.statusLight} ${styles.activeLight}`}
                ></div>
                <div
                  className={`${styles.statusLight} ${styles.pulseLight}`}
                ></div>
                <div
                  className={`${styles.statusLight} ${styles.activeLight}`}
                ></div>
              </div>

              {/* Signal waves */}
              <div className={styles.signalWave}></div>
              <div className={styles.signalWave}></div>
            </div>

            {/* Base with moving parts */}
            <div className={styles.botBase}>
              <div className={styles.wheel}></div>
              <div className={styles.wheel}></div>
            </div>
          </div>
          {/* Divider Line */}
        <div className={styles.divider}></div>
        </div>
      </section>


      {/* Special Product Highlight Section */}
      <section className={styles.specialProductSection}>
        <div className={styles.specialProductContainer}>
          {/* Subtle accent border */}
          <div className={styles.accentBorder}></div>

          {/* Minimal Premium Badge */}
          <div className={styles.premiumBadge}>FLAGSHIP PRODUCT</div>

          <div className={styles.specialProductHeader}>
            <div className={styles.productLogo}>
              <div className={styles.logoContainer}>
                <span className={styles.heroTitle}>CallCentry</span>
              </div>
            </div>
            <h1 className={styles.productTitle}>Advanced Voice Outreach</h1>
            <p className={styles.productTagline}>
              Automating outbound engagement for the mortgage industry.
            </p>
          </div>

          <div className={styles.productSlogan}>
            <h3 className={styles.sloganTitle}>
              The Future of Lead Management
            </h3>
            {/* <p className={styles.sloganText}>
              Call Sentry is an advanced AI system that automates outbound calls,
              engages customers directly from your CRM with relevant mortgage
              information, and intelligently transfers interested leads to human
              agents.
            </p> */}
          </div>

          {/* Core Features - Clean Grid */}
          <div className={styles.coreFeatures}>
            <h3 className={styles.sectionTitle}>CORE FEATURES</h3>
            <div className={styles.featuresGrid}>
              <div className={styles.featureItem}>
                <div className={styles.featureNumber}>01</div>
                <h4 className={styles.featureTitle}>
                  Personalized CRM Integration
                </h4>
                <p className={styles.featureDesc}>
                  Retrieves customer data points for natural, relevant
                  conversations.
                </p>
              </div>

              <div className={styles.featureItem}>
                <div className={styles.featureNumber}>02</div>
                <h4 className={styles.featureTitle}>Smart Agent Handoff</h4>
                <p className={styles.featureDesc}>
                  Transfers engaged leads with AI-generated conversation
                  summaries.
                </p>
              </div>

              <div className={styles.featureItem}>
                <div className={styles.featureNumber}>03</div>
                <h4 className={styles.featureTitle}>Disinterest Filtering</h4>
                <p className={styles.featureDesc}>
                  Filters out disinterested leads to focus on high-potential
                  prospects.
                </p>
              </div>
            </div>
          </div>

          {/* Feature Deep Dive */}
          <div className={styles.deepDiveSection}>
            <h3 className={styles.sectionTitle}>HOW IT WORKS</h3>
            <div className={styles.workflowGrid}>
              <div className={styles.workflowStep}>
                <div className={styles.stepIcon}>
                  <FaPhoneAlt />
                </div>
                <h4 className={styles.stepTitle}>Automated Outreach</h4>
                <ul className={styles.stepPoints}>
                  <li>Proactive engagement based on CRM triggers</li>
                  <li>Natural mortgage product introductions</li>
                  <li>Real-time sentiment analysis</li>
                </ul>
              </div>

              <div className={styles.workflowStep}>
                <div className={styles.stepIcon}>
                  <FaBullseye />
                </div>
                <h4 className={styles.stepTitle}>Real-Time Qualification</h4>
                <ul className={styles.stepPoints}>
                  <li>Instant response analysis</li>
                  <li>Lead prioritization</li>
                  <li>Smooth transition to agents</li>
                </ul>
              </div>

              <div className={styles.workflowStep}>
                <div className={styles.stepIcon}>
                  <FaUsers />
                </div>
                <h4 className={styles.stepTitle}>Agent Focus</h4>
                <ul className={styles.stepPoints}>
                  <li>Only interested customers transferred</li>
                  <li>Complete context provided</li>
                  <li>Faster deal closure</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Industry Solutions */}
          <div className={styles.industrySection}>
            <h3 className={styles.sectionTitle}>INDUSTRY SOLUTIONS</h3>
            <div className={styles.industryGrid}>
              <div className={styles.industryCard}>
                <div className={styles.industryHeader}>
                  <div className={styles.industryIcon}>
                    <FaUniversity />
                  </div>
                  <div>
                    <h4 className={styles.industryName}>
                      Financial Institutions
                    </h4>
                    <p className={styles.industryType}>Banking Systems</p>
                  </div>
                </div>
                <ul className={styles.industryList}>
                  <li>Loan Product Outreach</li>
                  <li>Customer Reactivation</li>
                  <li>Compliance-Friendly Conversations</li>
                </ul>
              </div>

              <div className={styles.industryCard}>
                <div className={styles.industryHeader}>
                  <div className={styles.industryIcon}>
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <h4 className={styles.industryName}>Call Centers</h4>
                    <p className={styles.industryType}>BPO Solutions</p>
                  </div>
                </div>
                <ul className={styles.industryList}>
                  <li>AI First-Level Calling</li>
                  <li>Agent Productivity Boost</li>
                  <li>Performance Analytics</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Simple CTA */}
          <div className={styles.ctaSection}>
            <button className={styles.primaryCta}
            onClick={() => (window.location.href = "/ccai-demo")}
            >
              Request a Demo</button>
          </div>
        </div>
      </section>
{/* onClick={() => (window.location.href = "/contactus")} */}
      

      {/* Filter Section */}
      <section className={styles.filterSection}>
        <h1 className={styles.productTitle}>Our Other Products...</h1>

        <div className={styles.filterContainer}>
          {categories.map((category) => (
            <button
              key={category.id}
              className={`${styles.filterButton} ${filter === category.id ? styles.activeFilter : ""}`}
              onClick={() => setFilter(category.id)}
            >
              {category.name}
              <span className={styles.filterCount}>{category.count}</span>
            </button>
          ))}
        </div>
      </section>

      {/* Projects Grid */}
      <section className={styles.projectsGridSection}>
        <div className={styles.projectsGrid}>
          {filteredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              className={styles.projectCard}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className={styles.projectImageContainer}>
                <img
                  src={project.image}
                  alt={project.title}
                  className={styles.projectImage}
                />
                <div
                  className={`${styles.statusBadge} ${styles[project.status]}`}
                >
                  {project.status.replace("-", " ")}
                </div>
              </div>

              <div className={styles.projectContent}>
                <div className={styles.projectMeta}>
                  <span className={styles.projectDate}>
                    {new Date(project.date).toLocaleDateString("en-US", {
                      month: "short",
                      year: "numeric",
                    })}
                  </span>
                  <span
                    className={`${styles.projectCategory} ${styles[project.category]}`}
                  >
                    {project.category.toUpperCase()}
                  </span>
                </div>

                <h3 className={styles.projectTitle}>{project.title}</h3>
                <p className={styles.projectDescription}>
                  {project.description}
                </p>

                <div className={styles.techStack}>
                  {project.tech.map((tech, idx) => (
                    <span key={idx} className={styles.techTag}>
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

{/* Divider Line */}
<div className={styles.divider}></div>
      
      {/* CTA Section */}
      {/* <section className={styles.ctaSection}>
        <div className={styles.ctaContainer}>
          <h2 className={styles.ctaTitle}>Have a Project in Mind?</h2>
          <p className={styles.ctaText}>
            Let's discuss how we can bring your AI vision to life with our
            expertise and cutting-edge technology.
          </p>
          <div className={styles.ctaButtons}>
            <button
              className={styles.secondaryCta}
              onClick={() => (window.Location.href = "/contactus")}
              >
              Schedule a Demo
            </button>
          </div>
        </div>
      </section> */}
      <Pricing />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Projects;
